import React, { useEffect, useState } from "react";

export default function OtpTimer({ expiry }) {
  const [timeLeft, setTimeLeft] = useState(expiry);
  useEffect(() => {
    localStorage.expiry = timeLeft
  }, [timeLeft])

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  return (
    <div>
      {timeLeft > 0 ? (
        <p>OTP expires in {timeLeft}s</p>
      ) : (
        <p style={{ color: "red" }}>OTP Expired</p>
      )}
    </div>
  );
}